import React, { useEffect, useState } from "react";
import { Modal, Input, Checkbox, Empty } from "antd";

const { Search } = Input;

const ProtectionZonePersonnelModal = ({
  open,
  station,
  personnel,
  onClose,
  onConfirm,
  confirming,
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (open && station) {
      const existing = Array.isArray(station.allowed_personnel_ids)
        ? station.allowed_personnel_ids
        : [];
      setSelectedIds(existing);
      setSearch("");
    }
  }, [open, station]);

  const filteredPersonnel = (personnel || []).filter((p) =>
    [p.name, p.company, p.jobTitle]
      .filter(Boolean)
      .some((field) => field.toLowerCase().includes(search.toLowerCase())),
  );

  const handleToggle = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };

  const handleOk = async () => {
    try {
      const ids = selectedIds.length > 0 ? selectedIds : null;
      await onConfirm(station.id, ids);
      onClose();
    } catch (_) {
      // keep modal open on error
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      title="防護區人員白名單"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="確定"
      cancelText="取消"
      confirmLoading={confirming}
      destroyOnClose
      width={400}
    >
      {station && (
        <>
          <Search
            placeholder="搜尋姓名、公司、職稱"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            allowClear
            style={{ marginBottom: 12 }}
          />
          <div
            style={{
              maxHeight: 300,
              overflowY: "auto",
              border: "1px solid #f0f0f0",
              borderRadius: 6,
              padding: "4px 0",
            }}
          >
            {filteredPersonnel.length === 0 ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="無符合人員"
                style={{ margin: "16px 0" }}
              />
            ) : (
              filteredPersonnel.map((p) => (
                <div
                  key={p.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 12px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleToggle(p.id)}
                >
                  <Checkbox
                    checked={selectedIds.includes(p.id)}
                    onChange={() => handleToggle(p.id)}
                    onClick={(e) => e.stopPropagation()}
                    style={{ marginRight: 10 }}
                  />
                  <div>
                    <div style={{ fontWeight: 500 }}>{p.name}</div>
                    {(p.company || p.jobTitle) && (
                      <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                        {[p.company, p.jobTitle].filter(Boolean).join(" · ")}
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
          <div style={{ marginTop: 8, fontSize: 12, color: "#8c8c8c" }}>
            已選 {selectedIds.length} 人
            {selectedIds.length === 0 &&
              "（未選擇任何人員時，所有人進入皆會觸發警報）"}
          </div>
        </>
      )}
    </Modal>
  );
};

export default ProtectionZonePersonnelModal;
